import { writable, derived } from "svelte/store";
import { Tasks, TaskRequest } from "../proto/task_pb";
import { TaskServicePromiseClient } from "../proto/task_grpc_web_pb";
import Tasksvc from "./services/task";
import EnumStatus from "./services/taskstatus";


export const alert = writable([]);
export const tasks = writable([]);
export const apiurl = VITE_APIURL;

export const createWritableStore = (key, startValue, endValue) => {
    const { subscribe, set } = writable(startValue);

    return {
        subscribe,
        set,
        useLocalStorage: () => {
            const json = localStorage.getItem(key);
            if (json) {
                set(JSON.parse(json));
            }

            subscribe(current => {
                localStorage.setItem(key, JSON.stringify(current));
            });
        }
    };
}

export const user = createWritableStore('user', {logged_in: false, accessToken: "notset"});

//Check JWT expiry and reset user store
function checkJWTExpiry() {

}

//Thoughts by project
export function filterThoughtsByProject(projectid) {
    let tmptasks = get__store(tasks)
    return tmptasks.filter((item) => item.projectid == projectid);
}

export function get__store(store) {
    let $val
    store.subscribe($ => $val = $)()
    return $val
  }
/* export const filteredPostStore = derived([allPostStore, filteredText], ([$allPostStore, $filteredText]) => {
    return $allPostStore.filter((item) => item.title.includes($filteredText));
}) */

//Filtered Thoughts
export const thougthsTasks = derived(
    [tasks],
    ([$tasks]) => {
        return filterByThoughts($tasks)
    }
)

function filterByThoughts(tasks) {
    return tasks.filter((item) => item.status == EnumStatus.THOUGHT);
}

//Delegated
export const delegatedTasks = derived(
    [tasks],
    ([$tasks]) => {
        return filterByDelegated($tasks)
    }
)

function filterByDelegated(tasks) {
    return tasks.filter((item) => item.status == EnumStatus.DELEGATED);
}

//Next
export const nextTasks = derived(
    [tasks],
    ([$tasks]) => {
        return filterByNext($tasks)
    }
)

function filterByNext(tasks) {
    return tasks.filter((item) => item.status == EnumStatus.ASAP);
}

//somedayTasks
export const somedayTasks = derived(
    [tasks],
    ([$tasks]) => {
        return filterBySomeday($tasks)
    }
)

function filterBySomeday(tasks) {
    return tasks.filter((item) => item.status == EnumStatus.SOMEDAY);
}    


//scheduled
export const scheduledTasks = derived(
    [tasks],
    ([$tasks]) => {
        return filterByScheduled($tasks)
    }
)

function filterByScheduled(tasks) {
    return tasks.filter((item) => item.status == EnumStatus.SCHEDULED);
}

export function addTask(data) {
    console.log("store-addTask")
    //TODO: check title?
    myTasksCall("add",data)
        .then((response) => {
            console.log("store: addTask", response)
            tasks.update(n => [...n, response]);
            alert.update(n => [...n, "Added Task"]);
        })
        .catch((error) => {
            console.log("store-addTask error", error);
            alert.update(n => [...n, "Failed to add Task"]);
        });    
}

export function updateTask(data) {
    console.log("store-updateTask")
    myTasksCall("update",data)
        .then((response) => {
            console.log("store: updateTask", response)
            tasks.update(n => [...n, response]);
            alert.update(n => [...n, "Updated Task"]);
            return response;
        })
        .catch((error) => {
            console.log("error", error);
            alert.update(n => [...n, error]);
            return error;
        }); 
}

export function refreshTasks() {
  console.log("I'm going to refresh the tasks grpc")
  getTasks();
}

function getTasks() {
    myTasksCall("index")
        .then((response) => {
            console.log("store: getTasks:", response)
            tasks.set(response);
        })
        .catch((error) => {
            alert.update(n => [...n, "Error Updating Tasklist"]);
            console.log("error", error);
        });
}

async function myTasksCall(callType, data) {
    const getMetadata = () => {
        return {
            ["X-CSRF-Token"]: get__store(user).accessToken,//'localStorage.getItem("X-CSRF-Token")',
        };
    };

    var deps = {
        getMetadata,
        proto: {
            TaskRequest,
            Tasks,
            TaskClient: TaskServicePromiseClient,
        },
    };

    let task = new Tasksvc(deps);
    if (callType == "index") {
        return await task.index();
    }
    if (callType == "add") {
        return await task.add(data);
    }
    if (callType == "update") {
        return await task.update(data);
    } 
    if (callType == "completed") {
        return await task.completed(data);
    }    
}


export default {
    apiurl,
    tasks,
    alert,
    user,
    delegatedTasks,
    thougthsTasks,
    updateTask,
    addTask,
    delegatedTasks,
    nextTasks,
    scheduledTasks,
    somedayTasks
};